// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import interpellationSignatoryEntity from './entities/interpellation-signatory.json';
import interpellationSignatoryMenu from '../pages/interpellation-signatory/menu.json';
import interpellationSignatoryFullForm from '../pages/interpellation-signatory/forms/full.json';
import interpellationSignatoryContextForm from '../pages/interpellation-signatory/forms/context.json';
import interpellationSignatoryMiniForm from '../pages/interpellation-signatory/forms/mini.json';
import interpellationSignatoryLookupForm from '../pages/interpellation-signatory/forms/lookup.json';
import interpellationSignatoryTableView from '../pages/interpellation-signatory/views/table.json';
import interpellationSignatoryCardsView from '../pages/interpellation-signatory/views/cards.json';
import interpellationSignatoryCalendarView from '../pages/interpellation-signatory/views/calendar.json';
import interpellationSignatoryDashboardView from '../pages/interpellation-signatory/views/dashboard.json';

/** Тип запису «Підписант» зі сторінками пакета: меню, форми та подання з pages/interpellation-signatory/. */
export const interpellationSignatoryDefinition: IRecordTypeDefinition = {
  ...interpellationSignatoryEntity,
  views: assembleViewSet({
      table: interpellationSignatoryTableView,
      cards: interpellationSignatoryCardsView,
      calendar: interpellationSignatoryCalendarView,
      dashboard: interpellationSignatoryDashboardView,
  }),
  form: interpellationSignatoryFullForm,
  forms: { full: interpellationSignatoryFullForm, context: interpellationSignatoryContextForm, mini: interpellationSignatoryMiniForm, lookup: interpellationSignatoryLookupForm },
  menu: interpellationSignatoryMenu,
} as IRecordTypeDefinition;
